import { cx } from "../../utils";

export const TextSkeleton = ({
  className,
  size = "base"
}: {
  className?: string;
  size?: "xxs" | "xs" | "sm" | "base" | "lg" | "xl" | "2xl" | "3xl";
}) => {
  const height = {
    xxs: "h-[16px]",
    xs: "h-[16px]",
    sm: "h-[20px]",
    base: "h-[24px]",
    lg: "h-[28px]",
    xl: "h-[28px]",
    "2xl": "h-[32px]",
    "3xl": "h-[36px]"
  }[size];

  return (
    <div
      className={cx(
        "animate-pulse rounded-lg bg-alpha-100",
        height,
        className || "w-full"
      )}
    />
  );
};
